export const meta = { id: 'O28', slug: 'obrigatorio-opcional', title: 'Obrigatório x Opcional', description: 'Defina quais Componentes são necessários para concluir a Formação e quais enriquecem o percurso.', profile: 'owner', category: 'formacoes', type: 'concept', status: 'published', order: 580, keywords: ['obrigatório','opcional','conclusão','componente','formação'], previous: 'O27', next: 'O29', related: ['O25','O33'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Obrigatório x Opcional

A obrigatoriedade influencia diretamente a conclusão da Formação.

- **Obrigatório:** precisa ser atendido para a conclusão.
- **Opcional:** pode enriquecer a experiência, mas não bloqueia a conclusão.

<HelpImage pendingId="O27.1" alt="Configuração de Componente obrigatório ou opcional" />

<Callout type="important">Não marque todos os Componentes como obrigatórios por padrão. Use essa regra apenas quando a experiência for realmente necessária para concluir a Formação.</Callout>
